import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import InitialLoadProgress from './InitialLoadProgress';
import Logo from './LoadingLogo';
import styles from './LoadingScreen.module.css';
export default function LoadingScreen(_a) {
    var noOfPendingImages = _a.noOfPendingImages, noOfLoadedImages = _a.noOfLoadedImages, isPro = _a.isPro, isEmbedded = _a.isEmbedded, areHotspotsLoaded = _a.areHotspotsLoaded, companyIcon = _a.companyIcon, companyColour = _a.companyColour;
    if (isEmbedded) {
        return null;
    }
    if (noOfPendingImages === 0 && areHotspotsLoaded) {
        return null;
    }
    var noOfSteps = noOfPendingImages + noOfLoadedImages;
    var completedStep = noOfLoadedImages;
    var backgroundStyle = cx(styles.loader, !companyColour && {
        'bg-white': isPro,
        'bg-blue': !isPro,
    });
    return (React.createElement("div", { className: backgroundStyle, style: companyColour ? { backgroundColor: "#".concat(companyColour) } : undefined },
        React.createElement("div", { className: cx('position-absolute', 'pinAll') },
            React.createElement("div", { className: cx('display-table', 'width-100', 'height-100') },
                React.createElement("div", { className: cx('display-tableCell', 'verticalAlign-middle') },
                    React.createElement("div", { className: cx('marginBottom-l') },
                        React.createElement(Logo, { companyIcon: companyIcon, isPro: isPro })),
                    React.createElement(InitialLoadProgress, { companyColour: companyColour, isPro: isPro, noOfImagesLoaded: completedStep, noOfImagesToPreload: noOfSteps }))))));
}
LoadingScreen.propTypes = {
    isPro: PropTypes.bool.isRequired,
    isEmbedded: PropTypes.bool.isRequired,
    areHotspotsLoaded: PropTypes.bool,
    noOfPendingImages: PropTypes.number.isRequired,
    noOfLoadedImages: PropTypes.number.isRequired,
    companyIcon: PropTypes.string,
    companyColour: PropTypes.string,
};
LoadingScreen.defaultProps = {
    isEmbedded: false,
    noOfPendingImages: 0,
    noOfLoadedImages: 0,
};
